export const isPropertyAddress = (property) => {
  const { City, State, Line1, Zip } = property?.Address || property?.address || {};
  return !!City && !!State && !!Line1 && !!Zip;
};
